export default {
  sentiment: 'Sentimento',
  medias: 'Mídias',
};
